module.exports = __webpack_public_path__ + "img/health35_7-9-2021.d12addd2.jpg";